<template>
  <div class="container py-20">
    <div class="row">
      <h1
        class="title-head text-[#000] text-[60px] font-Approach font-semibold uppercase text-center"
      >
        We Provide Full Assistance <br />
        In Your Business
      </h1>

      <div
        class="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 gap-5 gap-y-20 mt-16"
      >
        <div class="mission-card flex items-center gap-5">
          <div class="body-missions flex items-center gap-5 z-[99999]">
            <img src="@/assets/images/Group.svg" />
            <h1 class="text-[#000] text-[24px] font-semibold font-Approach">
              Plans <br />
              Builder
            </h1>
          </div>
        </div>
        <div class="mission-card flex items-center gap-5">
          <div class="body-missions flex items-center gap-5 z-[99999]">
            <img src="@/assets/images/Group.svg" />
            <h1 class="text-[#000] text-[24px] font-semibold font-Approach">
              Client Data <br />
              Management
            </h1>
          </div>
        </div>
        <div class="mission-card flex items-center gap-5">
          <div class="body-missions flex items-center gap-5 z-[99999]">
            <img src="@/assets/images/Group.svg" />
            <h1 class="text-[#000] text-[24px] font-semibold font-Approach">
              Flexible <br />
              SUBSCRIBE <br />
            </h1>
          </div>
        </div>
        <div class="mission-card flex items-center gap-5">
          <div class="body-missions flex items-center gap-5 z-[99999]">
            <img src="@/assets/images/Group.svg" />
            <h1 class="text-[#000] text-[24px] font-semibold font-Approach">
              Team <br />
              Scalability
            </h1>
          </div>
        </div>
        <div class="mission-card flex items-center gap-5">
          <div class="body-missions flex items-center gap-5 z-[99999]">
            <img src="@/assets/images/Group.svg" />
            <h1 class="text-[#000] text-[24px] font-semibold font-Approach">
              Food&Workout <br />
              library
            </h1>
          </div>
        </div>
        <div class="mission-card flex items-center gap-5">
          <div class="body-missions flex items-center gap-5 z-[99999]">
            <img src="@/assets/images/Group.svg" />
            <h1 class="text-[#000] text-[24px] font-semibold font-Approach">
              Insightful <br />
              reports
            </h1>
          </div>
        </div>
        <div class="mission-card flex items-center gap-5">
          <div class="body-missions flex items-center gap-5 z-[99999]">
            <img src="@/assets/images/Group.svg" />
            <h1 class="text-[#000] text-[24px] font-semibold font-Approach">
              Custom <br />
              Branding
            </h1>
          </div>
        </div>
        <div class="mission-card flex items-center gap-5">
          <div class="body-missions flex items-center gap-5 z-[99999]">
            <img src="@/assets/images/Group.svg" />
            <h1 class="text-[#000] text-[24px] font-semibold font-Approach">
              Plans <br />
              Builder
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Business-Component",
};
</script>
<style lang="scss">
@import "~/public/styles/misions/index.scss";
</style>
